// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"015d6f1d","114":"2d21107c","288":"52b8aed2","887":"b0ba81c9"}[chunkId] + ".chunk.js";
};